<template>
  <ul>
    <li
      v-for="(item, index) in topicList"
      :key="item.id"
      @mouseenter="showButton(index)"
      @mouseleave="hideButton(index)"
    >
      <div class="avatar">
        <img class="img" :src="item.avatar" />
        <div class="info">
          <p class="name">
            <span>{{ item.nickname }}</span>
            <span
              :class="{
                'user-type': true,
                'user-type-admin': item.user_type === 4,
              }"
            >
              {{ item.user_type | enum("UserType") }}
            </span>
          </p>
          <p class="time" v-if="item.created_at">
            {{ item.created_at | getTime }}
          </p>
        </div>
      </div>
      <div class="content">
        <p
          :class="['articleTitle', origin == 1 ? 'classesTitle' : '']"
          @click="onToPost(item)"
        >
          <img
            class="tag-top"
            v-if="item.is_top"
            src="@/assets/images/community/isTop.png"
          />
          <img
            class="tag-fine tag-top"
            v-if="item.is_fine"
            src="@/assets/images/community/isFine.png"
          />
          <span :class="['plate', 'plateAfter']" v-if="item.plate_name">
            {{ item.plate_name }}
          </span>
          <span class="title-text" v-if="origin == 2 && item.title">
            {{ item.title }}
          </span>
          <span
            class="title-text"
            v-if="origin == 1 && !item.title"
            v-html="item.content"
          ></span>
        </p>
        <p
          class="message"
          @click="onToPost(item)"
          v-if="origin == 2"
          v-html="item.content"
        ></p>
        <div
          class="circle-tag"
          @click="toCircle(item.group_id)"
          v-if="origin == 2"
        >
          <img src="@/assets/images/community/circle-icon.png" alt="" />
          <p>{{ item.group_name }}</p>
        </div>
        <div
          class="postImgsWrap"
          v-if="item.resources && item.resources.length"
        >
          <div v-for="i in item.resources" :key="i.id" class="postImgs">
            <img
              :src="i.resource_url"
              alt=""
              v-if="i.type == 1 && item.resources.length > 1"
              onerror="onerror=null;src='@/assets/images/errorImg.png'"
            />
            <el-image
              :src="i.resource_url"
              v-show="i.type == 1 && item.resources.length == 1"
              fit="cover"
              @load="imgLoad"
            ></el-image>
            <video
              :ref="'myVideo' + index"
              :src="i.resource_url"
              :controls="controls"
              v-show="i.type == 2"
            ></video>
            <img
              src="@/assets/images/community/play.png"
              alt=""
              class="playimg"
              v-if="i.type == 2 && isPlay"
              @click="playVideo(index)"
            />
          </div>
        </div>
        <SetBox
          @handleZan="handleZan"
          @handleComment="handleComment"
          :item="item"
          :index="index"
        />
        <div class="commentsWrap" v-if="item.showComment">
          <ReplayInput
            class="replyContent"
            @publishComment="publishComment"
            :post_id="item.id"
            :index="index"
            ref="replayInput"
            :disabled="
              item.plate &&
              !item.plate.who_can_reply_post.includes(
                $identity.getPlateIdentity(),
              )
            "
            :placeholder="
              item.plate &&
              !item.plate.who_can_reply_post.includes(
                $identity.getPlateIdentity(),
              )
                ? '当前帖子禁止评论'
                : ''
            "
          />
          <template v-if="item.comment && item.comment.length > 0">
            <CommontItem
              v-for="commentItem in item.comment"
              :key="commentItem.id"
              :item="commentItem"
              :post_id="item.id"
              :index="index"
              :commentId="commentItem.id"
              :plate="item.plate"
              @publishComment="publishComment"
              @handleDeleteComment="handleDeleteComment"
              @reply="reply"
              :can_reply_comment="can_reply_comment"
            />
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="
                val => {
                  return handle_current_comment_change(val, index);
                }
              "
              :page-size="limitComment"
              :current-page="item.pageComment"
              :total="item.totalPageComment"
              v-if="item.totalPageComment > 10"
            ></el-pagination>
          </template>
          <div style="text-align: center; line-height: 80px" v-else>
            暂无数据
          </div>
        </div>
      </div>
      <a
        class="operate delete"
        v-if="identify(item)"
        @click.stop="onDelete(item)"
      >
        删除
      </a>
      <a
        class="operate"
        v-else-if="handleComplain(item)"
        @click.stop="onComplaint(item)"
      >
        举报
      </a>
    </li>
    <EmptyNew v-if="topicList.length == 0" class="empty" title="暂无帖子！" />
    <el-pagination
      v-if="topicList.length > 0 && totalPage > 10"
      background
      layout="prev, pager, next"
      @current-change="handle_current_change"
      :page-size="limit"
      :current-page="page"
      :total="totalPage"
    ></el-pagination>
  </ul>
</template>
<script>
import CommontItem from "./CommentItem";
import ReplayInput from "./ReplayInput";
import SetBox from "./SetBox";
import EmptyNew from "@/components/EmptyNew.vue";

export default {
  name: "CommunityCircleItem",
  components: { CommontItem, ReplayInput, SetBox, EmptyNew },
  props: {
    activeTab: {
      type: String,
      default: "hot",
    },
    active: {
      type: String,
      default: "0",
    },
    group_id: {
      type: Number,
      default: 0,
    },
    plate_id: {
      type: String,
      default: "",
    },
    onlyMyself: {
      type: Boolean,
      default: false,
    },
    //1:班级圈子 2:社区
    origin: {
      type: String,
      default: "1",
    },
    isMcommunity: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    plate_id(newVal) {
      this.plate_id = newVal;
      this.page = 1;
      this.total = 0;
      this.getTopicList();
    },
    activeTab(newVal) {
      this.activeTab = newVal;
      this.page = 1;
      this.total = 0;
      this.getTopicList();
    },
    active(newVal) {
      this.active = newVal;
      this.page = 1;
      this.total = 0;
      this.requestList();
    },
    onlyMyself(newVal) {
      this.onlyMyself = newVal;
      this.page = 1;
      this.total = 0;
      this.getTopicList();
    },
  },
  data() {
    return {
      topicList: [], //帖子列表
      commentList: [], //评论列表
      post_id: "", //帖子ID
      commentId: "", //当前回复的评论ID
      commentIndex: "", //当前帖子下标
      controls: false, //视频控制条
      isPlay: true, //播放视频
      page: 1,
      limit: 10,
      totalPage: 0,
      pageComment: 1,
      limitComment: 10,
      totalPageComment: 0,
      showBtn: false,
      can_reply_comment: true, //是否有权限回复
      imgSizeByWidth: true, //图片尺寸根据宽来定义
    };
  },
  created() {
    if (this.isMcommunity) {
      this.requestList();
    } else {
      this.getTopicList();
    }
  },
  methods: {
    // 获取帖子列表 社区和班级圈子
    async getTopicList() {
      const that = this;
      let data = await that.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/post?`,
        {
          group_id: this.group_id ? this.group_id : "",
          plate_id: that.plate_id == "all" ? "" : that.plate_id, //版块
          tab: that.activeTab, //最新，最热
          page: that.page,
          limit: that.limit,
          user_id: this.onlyMyself ? this.$store.state.user_info.id : "",
          group_type: this.origin,
        },
      );
      that.topicList = data.data.map(item => {
        item.content = this.$pub.handleNewLine(item.content);
        item.showComment = false;
        item.showBtn = false;
        item.comment = [];
        item.pageComment = 1;
        return item;
      });
      that.totalPage = data.total;
    },
    // 我的圈子请求帖子列表
    async requestList(type) {
      type = type || this.active;
      this.topicList = [];
      switch (+type) {
        case 0:
          {
            const data = await this.$http.get(
              `/api/${this.$identity.getCommunityClientApiLetter()}/community/myPost`,
              {
                page: this.page,
                limit: this.limit,
                group_type: this.origin,
              },
            );
            this.total = data.total;
            this.topicList = data.data.map(item => {
              item.showComment = false;
              item.showBtn = false;
              item.comment = [];
              return item;
            });
          }
          break;
        case 1:
          {
            const data = await this.$http.get(
              `/api/${this.$identity.getCommunityClientApiLetter()}/community/myParticipate`,
              {
                page: this.page,
                limit: this.limit,
                group_type: this.origin,
              },
            );
            this.total = data.total;
            this.topicList = data.data.map(item => {
              item.showComment = false;
              item.showBtn = false;
              item.comment = [];
              return item;
            });
          }
          break;
        case 2:
          {
            const data = await this.$http.get(
              `/api/${this.$identity.getCommunityClientApiLetter()}/community/collect`,
              {
                // type: 6,
                page: this.page,
                limit: this.limit,
                group_type: this.origin,
              },
            );
            this.total = data.total;
            this.topicList = data.data.map(item => {
              item.showComment = false;
              item.showBtn = false;
              item.comment = [];
              return item;
            });
          }
          break;
        // case 4:
        //   this.total = 1;
        //   break;
      }
      if (this.total == 0 && this.page > 1) {
        this.page--;
        this.requestList();
      }
    },
    //前往帖子详情
    onToPost(item) {
      this.$router.push({
        name: "CommunityDetail",
        params: {
          id: this.active == 2 ? item.post_id : item.id,
          group_id: item.group_id,
          plate_id: item.plate_id,
          type: this.origin,
        },
      });
    },
    //展示删除/举报按钮
    showButton(index) {
      this.topicList[index].showBtn = true;
    },
    //隐藏删除/举报按钮
    hideButton(index) {
      this.topicList[index].showBtn = false;
    },
    //点赞
    async handleZan(post_id) {
      await this.$http.post(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/post/like`,
        { post_id },
      );
      if (this.isMcommunity) {
        this.requestList();
      } else {
        this.getTopicList();
      }
    },
    async onDelete(item) {
      await this.$promiseConfirm("删除后，该内容将不再展示，是否确认？", {
        type: "warning",
        customClass: "confirm-common",
      });
      await this.$http.delete(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/post/` +
          item.id,
      );
      if (this.isMcommunity) {
        this.requestList();
      } else {
        this.getTopicList();
      }
    },
    //打开评论
    handleComment(item, index) {
      this.commentIndex = index;
      this.post_id = this.active == 2 ? item.post_id : item.id;
      this.getCommentList(this.post_id, index);
      item.showComment = !item.showComment;
      if (
        item.plate &&
        item.plate.who_can_reply_comment.includes(
          this.$identity.getPlateIdentity(),
        )
      ) {
        this.can_reply_comment = true;
      } else {
        this.can_reply_comment = false;
      }
    },
    // 获取评论列表
    async getCommentList(id, index) {
      let data = await this.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/comment`,
        {
          post_id: id,
          page: this.topicList[index].pageComment,
          limit: this.limitComment,
        },
      );
      this.commentList = data.data.map(item => {
        item.content = this.$pub.handleNewLine(item.content);
        item.showCommentInput = false;
        return item;
      });
      this.topicList[index].comment = this.commentList;
      this.topicList[index].totalPageComment = data.total;
    },
    //获取回复的评论id
    reply(obj) {
      console.log("点击回复评论");
      this.post_id = obj.post_id;
      this.commentId = obj.id;
      this.commentIndex = obj.index;
    },
    //发布评论
    async publishComment(obj) {
      await this.$http.post(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/comment`,
        {
          post_id: obj.post_id,
          content: obj.comment,
          reply_id: obj.commentId > 0 ? obj.commentId : "",
        },
      );
      this.commentIndex = obj.index;
      this.post_id = obj.post_id;
      this.topicList[this.commentIndex].comment_num++;
      this.getCommentList(this.post_id, this.commentIndex);
      this.$refs.replayInput[0].comment = "";
    },
    //删除评论
    async handleDeleteComment(obj) {
      await this.$promiseConfirm("删除后，该内容将不再展示，是否确认？", {
        customClass: "confirm-common",
        type: "warning",
      });
      await this.$http.delete(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/comment/` +
          obj.id,
      );
      this.commentIndex = obj.index;
      this.post_id = obj.post_id;
      this.topicList[this.commentIndex].comment_num--;
      this.getCommentList(this.post_id, this.commentIndex);
    },
    //前往圈子
    toCircle(id) {
      this.$router.push({
        name: "CommunityGroupShow",
        params: { id },
      });
    },
    //举报
    onComplaint(item) {
      this.$emit("complaint", item);
    },
    //播放视频
    playVideo(index) {
      //列表循环video 需要指定唯一ref
      this.$refs["myVideo" + index][0].play();
      this.controls = true;
      this.isPlay = false;
    },
    // 评论分页加载数据
    handle_current_comment_change(val, index) {
      this.topicList[index].pageComment = val;
      this.getCommentList(this.post_id, index);
    },
    // 帖子分页加载数据
    handle_current_change(val) {
      this.page = val;
      this.getTopicList();
    },
    //图片加载成功回调
    imgLoad(e) {
      let imgWidth = e.path[0].clientWidth;
      let imgHeight = e.path[0].clientHeight;
      if (imgWidth > imgHeight) {
        e.target.style.width = "250px";
        e.target.style.height = "188px";
      } else {
        e.target.style.width = "250px";
        e.target.style.height = "333px";
      }
    },
    //判断删除身份
    identify(item) {
      if (
        this.$identity.name == "student" &&
        item.user_type == 1 &&
        this.$store.state.user_info.id == item.user_id &&
        item.showBtn
      ) {
        return true;
      } else if (
        this.$identity.name == "teacher" &&
        item.user_type == 2 &&
        this.$store.state.user_info.id == item.user_id &&
        item.showBtn
      ) {
        return true;
      } else if (
        this.$identity.name == "assist" &&
        item.user_type == 3 &&
        this.$store.state.user_info.id == item.user_id &&
        item.showBtn
      ) {
        return true;
      } else {
        return false;
      }
    },
    //判断举报身份
    handleComplain(item) {
      if (item.user_type != 1) {
        return true;
      } else if (
        this.$identity.name == "student" &&
        item.showBtn &&
        this.$store.state.user_info.id != item.user_id
      ) {
        return true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-pagination {
  margin-bottom: 23px;
}
li {
  width: 100%;
  padding-top: 24px;
  overflow: hidden;
  position: relative;
  .operate {
    position: absolute;
    cursor: pointer;
    top: 28px;
    right: 0;
    font-size: 14px;
    color: #999999;
    &:hover {
      color: $primary-color;
    }
    &.delete:hover {
      color: #e74d3d;
    }
  }
  .avatar {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    .img {
      width: 46px;
      height: 46px;
      border-radius: 50%;
      margin-right: 12px;
      border: 1px solid #e7e7e7;
    }
    .info {
      display: inline-block;
      max-width: 100%;
      border-radius: 30px;
      box-sizing: border-box;
      .name {
        font-size: 15px;
        font-weight: 500;
        color: rgba(32, 36, 42, 1);
        display: flex;
        align-items: center;
        .user-type {
          color: $primary-color;
          border: 1px solid $primary-color;
          font-size: 13px;
          transform: scale(0.9);
          padding: 0 4.9px;
          border-radius: 3px;
          margin-left: 5px;
          font-weight: 400;
          line-height: 19px;
        }
        .user-type-admin {
          background-color: #666564;
          color: #ead2ab;
          border: 0;
        }
      }
      .time {
        color: #999;
        font-size: 13px;
        margin-top: 2px;
      }
      div {
        display: flex;
        margin-top: 10px;
        p {
          margin-right: 15px;
          font-size: 12px;
          color: #8c8c8c;
          line-height: 12px;
          span {
            display: inline-block;
            margin: 0 5px;
            color: $primary-color;
            cursor: pointer;
          }
        }
      }
    }
  }
  .content {
    margin-left: 63px;
    margin-top: 7px;
    padding-bottom: 24px;
    border-bottom: 1px solid #edf1f2;
    .articleTitle {
      margin-bottom: 4px;
      line-height: 24px;
      // display: flex;
      // align-items: center;
      .tag-top {
        width: 30px;
        height: 18px;
        vertical-align: -4px;
      }
      .tag-fine {
        width: 18px;
        margin: 0 8px 0 6px;
      }
      .plate {
        font-weight: 600;
        color: #333333;
        font-size: 14px;
        margin-right: 16px;
        position: relative;
      }
      .plateAfter {
        &::after {
          content: "";
          width: 1px;
          height: 14px;
          background: #666;
          position: absolute;
          top: 3px;
          right: -8px;
        }
      }
      .title-text {
        font-size: 14px;
        color: #333;
        line-height: 24px;
        cursor: pointer;
      }
    }
    .classesTitle {
      display: block;
    }
    .message {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      font-size: 14px;
      color: #666666;
      cursor: pointer;
      line-height: 24px;
    }
    .circle-tag {
      align-items: center;
      font-size: 13px;
      color: #f09208;
      background: #fff6e9;
      border-radius: 24px;
      padding: 5px 10px;
      display: inline-flex;
      margin: 8px 0 0 0;
      cursor: pointer;
      img {
        width: 12px;
        height: 11px;
        margin-right: 6px;
      }
    }
    .postImgsWrap {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin: 16px 0 20px 0;
      .postImgs {
        margin-right: 4px;
        position: relative;
        &:last-child {
          margin: 0;
        }
        img {
          width: 80px;
          height: 80px;
        }
        video {
          width: 250px;
          max-height: 333px;
        }
        .playimg {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 48px;
          height: 48px;
          cursor: pointer;
          padding: 20px;
        }
      }
    }
    .img-box {
      width: 360px;
      & /deep/ .el-image {
        display: block;
        width: 100%;
        height: 110px;
        margin-top: 20px;
        background-color: rgba(0, 0, 0, 0.1);
        cursor: zoom-in;
      }
    }
    .set-box {
      margin-top: 20px;
      overflow: hidden;
      line-height: 40px;
      background: #f7f7f7;
      display: flex;
      justify-content: space-around;
      align-items: center;
      p {
        font-size: 14px;
        color: #666;
        .set-num {
          margin: 0 5px;
        }
      }
      .zan {
        display: inline-block;
        padding-left: 20px;
        background: url("~@/assets/images/icon_fourm_zan.png") left no-repeat;
        background-size: 20px 20px;
        cursor: pointer;
      }
      .cancelzan {
        background: url("~@/assets/images/icon_fourm_cancleZan.png") left
          no-repeat;
        background-size: 20px 20px;
        cursor: pointer;
      }
      .comment {
        display: inline-block;
        margin-left: 30px;
        padding-left: 21px;
        background: url("~@/assets/images/icon_fourm_comment.png") left center
          no-repeat;
        background-size: 20px 20px;
        cursor: pointer;
      }
      .browse {
        display: inline-block;
        margin-left: 30px;
        padding-left: 20px;
        background: url("~@/assets/images/icon_fourm_browse.png") left no-repeat;
        background-size: 20px 20px;
      }
    }
    .commentsWrap {
      background: #f7f7f7;
      padding: 0 24px 1px 24px;
      .replyContent {
        border-bottom: 1px solid #e6e6e6;
        padding-top: 8px;
        padding-bottom: 20px;
      }
    }
  }
}
</style>
